import { getWaterMonth, getMonth, getSeason } from 'utils'
import { ToolTipLabelType } from '../../interfaces'

const ToolTipLabel = ({
  x,
  y,
  datum,
  color,
  year,
  style,
  textAnchor,
  unit,
  isSeasonal = false,
  isStreamFlowMonths = false
}: ToolTipLabelType) => {
  return (
    <text style={style} x={x} y={y} textAnchor={textAnchor}>
      <tspan style={{ fontSize: 10 }} dx={2} dy={-10}>
        {isSeasonal
          ? getSeason(datum?.x ?? 0)
          : isStreamFlowMonths
          ? getWaterMonth(datum?.x ?? 0)
          : getMonth(datum?.x ?? 0)}
      </tspan>
      <tspan style={{ fill: color }} dx={-15} dy={25}>
        ●
      </tspan>
      <tspan> {year}: </tspan>
      <tspan
        style={{
          fontSize: 14,
          fontFamily: 'Arial',
          fontWeight: 'bold',
          fill: '#6E6E6E'
        }}
      >
        {Math.round(datum ? datum.y * 100 : 100) / 100}
        {unit ? unit : ' GL'}
      </tspan>
    </text>
  )
}

const ToolTipLabelAverage = ({
  x,
  y,
  datum,
  color,
  year,
  style,
  textAnchor,
  unit,
  isSeasonal = false,
  isStreamFlowMonths = false
}: ToolTipLabelType) => {
  return (
    <text style={style} x={x} y={y} textAnchor={textAnchor}>
      <tspan style={{ fontSize: 10 }} dx={2} dy={-10}>
        {isSeasonal
          ? getSeason(datum?.x ?? 0)
          : isStreamFlowMonths
          ? getWaterMonth(datum?.x ?? 0)
          : getMonth(datum?.x ?? 0)}{' '}
        average
      </tspan>
      <tspan style={{ fill: color }} dx={-52} dy={25}>
        ●
      </tspan>
      <tspan> {year}: </tspan>
      <tspan
        style={{
          fontSize: 14,
          fontFamily: 'Arial',
          fontWeight: 'bold',
          fill: '#6E6E6E'
        }}
      >
        {Math.round(datum ? datum.y * 100 : 100) / 100}
        {unit ? unit : ' GL'}
      </tspan>
    </text>
  )
}

export { ToolTipLabel, ToolTipLabelAverage }
